import PendingResidentTable from './PendingResidentTable';

export const PendingResident = () => {
  return (
    <div className="pb-10">
      <h2 className="text-pry-text font-opensans font-medium mb-3">
        Pending Residents
      </h2>
      <PendingResidentTable />
    </div>
  );
};
